import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:"",
    router:{},
    axios:{},
    initialPathName:"",
    userName:"",
    musteriId:"",
    admin:false,
    adSoyad:""
  },
  mutations: {
    setSession(state,token){
      console.log("set session called with token  ",token);
      token = "Bearer "+token;
      localStorage.setItem("app-token",token);
      state.token = token;
      window.axios.defaults.headers.common['Authorization'] = token;
      //state.router.push("index");
    },
    clearSession(){
      localStorage.removeItem("app-token");
    },
    push(state, route) {
      console.log("Push mutation is called with router ", route);
      state.router.push(route);
    },
    setRouter(state, router) {
      console.log("setRouter mutation is called");
      state.router = router;
    },
    setAxios(state, axios) {
      console.log("setAxios mutation is called");
      state.axios = axios;
    },
    setInitialPathName(state, pathName) {
      console.log("setInitialPathName mutation is called with", pathName);
      if (typeof pathName == "undefined" || pathName == '/login') {
        pathName = '/console';
      }
      state.initialPathName = pathName;
    },
  },
  actions: {
    init(context) {
      //console.log("axios",this.$axios);
      console.log("init started",context);
      context.commit('setInitialPathName', window.location.pathname);
      let token = window.localStorage.getItem('app-token');
      if (token != undefined) {
        context.state.axios.get("me").then(me=>{
          this.state.userName = me.data.userName;
          this.state.adSoyad = me.data.adSoyad;
          this.state.musteriId = me.data.musteriId;
          this.state.admin = me.data.admin;
          console.log("state",this.state);
          context.commit("push","index");
        }).catch(er=>{
          alert("Oturum bulunamadı");
          context.commit("push","login");
        })
        return;
      }else{
        context.commit("push","login");
        return;
      }
    }
  },
  modules: {
  },
  getters: {
    userName: state =>  {
      //console.log(state.userName);
      return state.userName;
    },
    adSoyad: state =>  {
      //console.log(state.userName);
      return state.adSoyad;
    },
    admin: state =>  {
      //console.log(state.userName);
      return state.admin;
    }
  }
  
})
